export default __webpack_public_path__ + "static/media/logo-full.771bb357.svg";